import { money0 } from "@keel/core";
import { Stat } from "@keel/ui";

/** Home dashboard: depreciation due but not yet run. */
export function DepreciationTile({
  data,
}: {
  data: { assets: number; dueAssets: number; dueMonths: number; dueAmount: number };
}) {
  return (
    <Stat
      label="Depreciation due"
      value={money0(data.dueAmount)}
      href="/depreciation"
      tone={data.dueAmount ? "warn" : undefined}
      foot={
        data.dueAmount
          ? `${data.dueMonths} months over ${data.dueAssets} assets`
          : `${data.assets} assets up to date`
      }
    />
  );
}
